<template>
    <div class="z-page">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less">
    .z-page{
        background:#fff;
        height:100%;
        position: relative;
        overflow: auto;
    }
</style>





